(() => {
  const qualifyingProducts = new Set([15419399667991, 10134739190039, 10127373238551]);
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let cleaning;
  async function removeIneligibleGifts() {
    if (cleaning) return cleaning;
    cleaning = (async () => {
      const response = await nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return false;
      const cart = await response.json();
      const quantity = cart.items.reduce((sum, item) => sum + (qualifyingProducts.has(item.product_id) ? item.quantity : 0), 0);
      if (quantity >= 3) return false;
      const gifts = cart.items.filter(item => item.properties?._vg_complete_look_gift === 'true');
      if (!gifts.length) return false;
      const removed = await nativeFetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: Object.fromEntries(gifts.map(item => [item.key, 0])) }) });
      return removed.ok;
    })();
    try { return await cleaning; } finally { cleaning = null; }
  }
  // Recheck the server discount after a customer removes a qualifying piece.
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || String(args[0]);
    if (response.ok && /\/cart\/(change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
      try { if (await removeIneligibleGifts()) window.location.reload(); } catch { /* The server still enforces eligibility at checkout. */ }
    }
    return response;
  };
  if (location.pathname.replace(/\/$/, '').endsWith('/cart')) removeIneligibleGifts().then(changed => { if (changed) location.reload(); }).catch(() => {});
})();
